import { ISuggestionItem } from '../../types/suggestions';
import { ITag } from '../../types/tags';

/**
 * Преобразует элемент саджеста в тэг
 * @param {ISuggestionItem} suggest - элемент саджеста
 * @returns {ITag}
 */
export const mapSuggestToTag = (suggest: ISuggestionItem): ITag => ({
  name: suggest.title,
  jsonQuery: suggest.jsonQuery,
});
